export default function fadeDeathClone(entity, time) {

	if (!entity) return;

	const wrapper = entity.closest(".enemy-wrapper") || entity;
	const rect = wrapper.getBoundingClientRect();
	const stage = document.createElement("div");
	const clone = wrapper.cloneNode(true);

	stage.className = "game-enemies enemy-die-stage";
	stage.style.left = rect.left + "px";
	stage.style.top = rect.top + "px";
	stage.style.width = rect.width + "px";
	stage.style.height = rect.height + "px";
	stage.style.transitionDuration = time + "ms";

	clone.querySelectorAll("[id]").forEach(node => node.removeAttribute("id"));
	clone.removeAttribute("id");
	clone.classList.add("enemy-die-clone");
	stage.appendChild(clone);

	(document.querySelector(".app") || document.body).appendChild(stage);
	requestAnimationFrame(() => stage.classList.add("enemy-die-anim"));
	setTimeout(() => stage.remove(), time);
}
